// extracted by mini-css-extract-plugin
export var equalColumn = "_gi-0";